import React,{Fragment} from "react";
import { Transfer, Table } from 'antd';
import difference from 'lodash/difference';

// Customize Table Transfer
const TableTransfer = ({ leftColumns, rightColumns,  ...restProps }) => {  
  return (
    (<Transfer {...restProps} showSelectAll={false}  >
      {({
        direction,
        filteredItems,
        onItemSelectAll,
        onItemSelect,
        selectedKeys: listSelectedKeys,
        disabled: listDisabled,
      }) => {
        const columns = direction === 'left' ? leftColumns : rightColumns;
       
        const rowSelection = {
          getCheckboxProps: item => ({ disabled: listDisabled || item.disabled }),
          onSelectAll(selected, selectedRows) {
            const treeSelectedKeys = selectedRows
              .filter(item => !item.disabled)
              .map(({ _id }) => _id);
            const diffKeys = selected
              ? difference(treeSelectedKeys, listSelectedKeys)
              : difference(listSelectedKeys, treeSelectedKeys);
            onItemSelectAll(diffKeys, selected);
          },
          onSelect({ _id }, selected) {
            onItemSelect(_id, selected);
          },
          selectedRowKeys: listSelectedKeys,
        };

        return (
          filteredItems && filteredItems.length > 0 ? (
            <Table
              rowSelection={rowSelection}
              columns={columns}
              dataSource={filteredItems}
              size="small"
              rowKey="_id"
              style={{ pointerEvents: listDisabled ? 'none' : null }}
              onRow={({ _id, disabled: itemDisabled }) => ({
                onClick: () => {
                  if (itemDisabled || listDisabled) return;
                  onItemSelect(_id, !listSelectedKeys.includes(_id));
                },
              })}
            />
          ) : null
        );
      }}
    </Transfer>)
  )
};

const leftTableColumns = [
  {
    dataIndex: 'role_name',
    title: 'User Roles',
  }
];
const rightTableColumns = [
  {
    dataIndex: 'role_name',
    title: 'User Roles',
  }
];

class TransferOne extends React.Component {
  state = {
    targetKeys:[],
    moveKeys:[],
    selectedKeys:[],
  };

  componentDidUpdate(prevProps, prevState) {    
    if (prevProps.initialValue !== this.props.initialValue) {
      const targetKeys = this.props.initialValue ? this.props.initialValue : [];
      this.setState({ targetKeys, selectedKeys: [] });
    }
  }

  onChange = async (nextTargetKeys, direction, moveKeys) => {
    await this.props.updateMappedRoles(nextTargetKeys);
    this.setState({ moveKeys: moveKeys });
    this.setState({ targetKeys: nextTargetKeys });
  };

  onSelectChange = (sourceSelectedKeys, targetSelectedKeys) =>{
    this.setState({selectedKeys:sourceSelectedKeys.length>0?sourceSelectedKeys:targetSelectedKeys})
  }

  triggerShowSearch = showSearch => {
    this.setState({ showSearch });
  };

  render() {

    return (
      <Fragment>
        <TableTransfer
          dataSource={this.props.roleGetData}
          targetKeys={this.state.targetKeys}
          selectedKeys={this.state.selectedKeys}
          onSelectChange={this.onSelectChange}
          lazy={false}
          disabled={false}
          showSearch={true}
          rowKey={record => record._id}
          locale={{
            itemUnit: "role",
            itemsUnit: "roles",
            notFoundContent: "No roles",
            searchPlaceholder: "Search here"
          }}
          onChange={this.onChange}
          filterOption={(inputValue, item) =>
            item.role_name.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 
          }
          leftColumns={leftTableColumns}
          rightColumns={rightTableColumns}
          listStyle={{
            width: "50%",
          }}
        />
      </Fragment>
    );
  }
}

export default TransferOne;